import React, { useState } from "react";
import styled from "styled-components";
import { Link as UnstyledLink } from "react-router-dom";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SelfServiceReport from "../interfaces/SelfServiceReport";
import ContextualMenu, {
  ContextualMenuItemProps,
  MenuAlignmentMode,
} from "components/Global/ContextualMenu";

const Container = styled.div`
  border-radius: 8px;
  border: 1px solid #80adce;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  &:not(:last-child) {
    margin-bottom: 25px;
  }

  &:hover {
    box-shadow: 0px 10px 20px 0px #1468a51a;
  }
`;

const MenuWrapper = styled.div`
  position: relative;

  ul {
    border-radius: 8px;
  }

  ul button {
    min-width: 100px;
    padding: 5px 10px;
    color: #1468a5;

    &:hover {
      background-color: rgba(0, 0, 0, 0.03);
    }
  }
`;

const Link = styled(UnstyledLink)`
  all: unset;
  height: 100%;
  padding: 20px 0 20px 25px;
  line-height: 20px;
  font-family: Inter, system-ui;
  font-size: 16px;
  font-weight: 500;
  color: #5f6368;
  cursor: pointer;
  flex-grow: 1;
`;

const Button = styled.button`
  all: unset;
  padding: 15px 25px;
  color: #1468a5;
  cursor: pointer;

  svg {
    display: block;
  }
`;

interface ReportCardProps {
  report: SelfServiceReport;
  editReport?: (selfServiceReportId: string) => void;
  duplicateReport: (report: SelfServiceReport) => Promise<void>;
  deleteReport?: (selfServiceReportId: string) => Promise<void>;
}

const ReportCard = (props: ReportCardProps) => {
  const { report, editReport, duplicateReport, deleteReport } = props;
  const [isReportMenuOpen, setReportMenuOpen] = useState(false);

  const editMenuItem = editReport
    ? {
        title: "Edit",
        onClick: () => {
          setReportMenuOpen(false);
          editReport(report.selfServiceReportId);
        },
      }
    : null;

  const duplicateMenuItem = {
    title: "Duplicate",
    onClick: async () => {
      setReportMenuOpen(false);
      duplicateReport(report);
    },
  };

  const deleteMenuItem = deleteReport
    ? {
        title: "Delete",
        onClick: async () => {
          setReportMenuOpen(false);
          deleteReport(report.selfServiceReportId);
        },
      }
    : null;

  const reportMenuItems = [
    editMenuItem,
    duplicateMenuItem,
    deleteMenuItem,
  ].filter(Boolean) as ContextualMenuItemProps[];

  return (
    <Container>
      <Link
        to={`/reporting/self-service-reports/view/${report.selfServiceReportId}`}
      >
        {report.name}
      </Link>
      <MenuWrapper>
        <Button onClick={() => setReportMenuOpen(true)}>
          <MoreVertIcon />
        </Button>
        {isReportMenuOpen && (
          <ContextualMenu
            alignmentMode={MenuAlignmentMode.TopTrailing}
            menuItems={reportMenuItems}
            onDismiss={() => setReportMenuOpen(false)}
          />
        )}
      </MenuWrapper>
    </Container>
  );
};

export default ReportCard;
